module.exports = __webpack_public_path__ + "img/fipp.dd9487ee.png";